import React, { ReactElement } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import { CreditRatingFormInputProps } from "./CRF.types";
import { CRFClassNameGenerator as c } from "./CRF.utils";

const StyledButton = styled("button")`
    border: solid 2px #ccc;
`;

const FormButtons = ({
    onCancel,
    onSubmit,
    t,
    showCancel = true,
    showContinue = true,
    cancelText,
    continueText,
    continueIcon,
}: {
    onCancel?: any;
    onSubmit?: any;
    showCancel?: boolean;
    showContinue?: boolean;
    cancelText?: string;
    continueText?: string;
    continueIcon?: ReactElement;
} & CreditRatingFormInputProps) => {
    return (
        <div className={c(["section", "buttons"])}>
            {showCancel && (
                <StyledButton className={c(["button", "cancel"])} type="reset" onClick={onCancel}>
                    {cancelText || t("SoftCreditPull.cancel")}
                </StyledButton>
            )}
            {showContinue && (
                <StyledButton className={c(["button", "submit"])} type="submit" onClick={onSubmit}>
                    {continueIcon}
                    {continueText || t("SoftCreditPull.continue")}
                </StyledButton>
            )}
        </div>
    );
};

export default withTranslation()(FormButtons);
